export const SKELETONS = {
  title: {
    width: "200px",
  },
};
